import { useDispatch } from 'react-redux'
import {UploadsService} from '../../../services'
import { showErrorToast, showSuccessToast } from '../../../state/toasts'
import * as components from '../../../components'
import * as ReactBootstrap from 'react-bootstrap'
import React from 'react'
import {UploadContent} from "../../../api";

export type AttachmentDeleteProps={
    document:UploadContent
    onDelete:(document:UploadContent)=>void
}

const AttachmentDelete = ({ document, onDelete }:AttachmentDeleteProps) => {
  const dispatch = useDispatch()
  let OnDeleteConfirm = function () {
    new UploadsService(document.url)
      .makeDeleteRequest()
      .then((response) => {
        onDelete(document)
        dispatch(showSuccessToast('Success', `Attachment has been deleted.`))
      })
      .catch((errors) => {
        dispatch(showErrorToast('Error', errors.response))
      })
  }
  return (
    <>
      <components.Confirm
        onConfirm={OnDeleteConfirm}
        body="Are you sure you want to delete this Upload"
        confirmText="Confirm Delete"
        confirmBSStyle="danger"
        title="Delete Upload"
        showCancelButton
      >
        <ReactBootstrap.Dropdown.Item>
          {components.ICONS.DELETE} Delete {document.description}
        </ReactBootstrap.Dropdown.Item>
      </components.Confirm>
    </>
  )
}

export default AttachmentDelete
